export const PERSONAL_CREDIT = 'Crédito Personal';
